export default "__VITE_ASSET__B$Lpa8V4__"